package com.mshopsas.enterprise.aiw.scan.data

import kotlinx.serialization.Serializable

@Serializable
data class Store(
    val storeUuid: String,
    val storeLabel: String
)
